import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import {
    Button,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { I18n } from 'aws-amplify';
import { useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import {
    addNewRowProjectCustomer,
    handleTextFieldAddChange,
    handlePhoneNumberChange,
    handleSubmit,
    checkDisableBtnSubmit,
    isFillUserData,
    reMoveRowProjectUser,
    onSubmitCancelEdit,
    onClickCancelEdit,
    isDisableBtnDeleteB2C,
    onClickDeleteB2C,
    handleEdit,
    validateEditUser,
    handlePhoneNumberChangeEdit,
    isDisableBtnEditB2C,
    isDisplayPopupCancelAddOrEditChecker,
    isDisableBtnRestoreB2C,
    handleClickRestoreB2C,
    onSubmitRestoreB2C
} from './handler/CustomerListInCorporationHandler';
import { clsx } from 'clsx';
import { getUserListInProjectByProjectId } from '@/service/userService';
import ConfirmDeleteAdditionUserDialog from './dialog/ConfirmDeleteAdditionUserDialog/ConfirmDeleteAdditionUserDialog';
import CancelEditCustomerList from './dialog/CancelEditCustomerList';
import { useSnackbar } from 'notistack';
import OverFlowTooltip from '../common/OverFlowTooltip';
import RejectDeleteCustomerUser from './dialog/RejectDeleteCustomerUser';
import ConfirmRestoreUser from '@/component/common/modal/ConfirmRestoreUser';
import DataChangePleaseReloadModal from '@/component/common/modal/DataChangePleaseReloadModal';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import './CustomerListInProject.css';
import { useRecoilState } from 'recoil';
import { listB2CUserListInOrgAtom } from '@/state/atom/voiceCallAtom';

export default function CustomerListInCorporation(props) {
    const { isAdmin, userDetail, projectDetail, corporationId } = props;
    const [listB2CUserListInOrg, setListB2CUserListInOrg] = useRecoilState(listB2CUserListInOrgAtom);
    const [userAddList, setUserAddList] = useState([]);
    const [errorAddList, setErrorAddList] = useState([]);
    const [isDisableBtnSubmit, setIsDisableBtnSubmit] = useState(true);
    const [isOpenDialogConfirmDelete, setIsOpenDialogConfirmDelete] = useState({
        isEnable: false,
        userId: null
    });
    const [customerList, setCustomerList] = useState([]);
    const [reloadListCustomer, setReloadCustomer] = useState(false);
    const [isOpenModalConfirmCancel, setIsOpenModalConfirmCancel] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [isOpenModalRejectDeleteUser, setIsOpenModalRejectDeleteUser] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [errorEditUser, setErrorEditUser] = useState({});
    const [isOpenDialogConfirmRestoreUser, setIsOpenDialogConfirmRestoreUser] = useState(false);
    const [selectedUser, setSelectedUser] = useState({});
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);
    const [editUserError, setEditUserError] = useState('');

    let argsAll = {
        ...props,
        userAddList,
        setUserAddList,
        errorAddList,
        setErrorAddList,
        setIsDisableBtnSubmit,
        userDetail,
        projectDetail,
        corporationId,
        customerList,
        setCustomerList,
        reloadListCustomer,
        setReloadCustomer,
        isOpenDialogConfirmDelete,
        setIsOpenDialogConfirmDelete,
        reMoveRowProjectUser,
        isOpenModalConfirmCancel,
        setIsOpenModalConfirmCancel,
        setIsLoading: props.setIsLoading,
        enqueueSnackbar,
        isOpenModalRejectDeleteUser,
        setIsOpenModalRejectDeleteUser,
        isEditMode,
        setIsEditMode,
        errorEditUser,
        setErrorEditUser,
        isOpenDialogConfirmRestoreUser,
        setIsOpenDialogConfirmRestoreUser,
        selectedUser,
        setSelectedUser,
        isOpenModalReloadPage,
        setIsOpenModalReloadPage,
        setEditUserError,
        listB2CUserListInOrg,
        setListB2CUserListInOrg
    };

    useEffect(() => {
        checkDisableBtnSubmit(argsAll);
        let isCancel = !Utils.isEmptyArray(userAddList) || isDisplayPopupCancelAddOrEditChecker(argsAll);
        props.parentCallBack(isCancel);
    }, [userAddList, customerList]);

    useEffect(() => {
        if (!Utils.isEmptyObject(projectDetail)) {
            props.setIsLoading(true);
            getUserListInProjectByProjectId(props?.API, projectDetail.id)
                .then(listCustomer => {
                    let sortedListCustomer = Utils.sortByCreatedAtDesc(listCustomer);
                    sortedListCustomer = sortedListCustomer?.filter(user => {
                        return user.type === Constant.USER_TYPE.CUSTOMER;
                    });
                    // Filter out users with fake phone email format
                    const filteredListCustomer = sortedListCustomer.map(
                        user => {
                            if(Utils.isFakePhoneUserEmail(user.mail)){
                                return {
                                    ...user,
                                    mail: '',
                                    isEmailFromPhoneCall: true
                                };
                            }
                            return user;
                        }
                    );
                    setCustomerList(filteredListCustomer);
                    
                    setReloadCustomer(false);
                    setIsDisableBtnSubmit(true);
                    setIsEditMode(false);
                    if(Utils.isEmpty(userAddList)){
                        setUserAddList([])
                    }
                    if(Utils.isEmpty(errorAddList)){
                        setErrorAddList([])
                    }
                    if(Utils.isEmpty(errorEditUser)){
                        setErrorEditUser([])
                    }

                    props.setIsLoading(false);
                })
                .catch(error => {
                    props.setIsLoading(false);
                });
        }
    }, [reloadListCustomer, projectDetail]);


    const renderStatusUser = status => {
        const classNameStatus = clsx({
            'status-user': true,
            'status-waiting': status === Constant.STATUS_OF_USER.WAITING,
            'status-reject': status === Constant.STATUS_OF_USER.REJECT,
            'status-active': status === Constant.STATUS_OF_USER.ACTIVE,
            'status-deleted': status === Constant.STATUS_OF_USER.DELETED,
            'status-notinvite': status === Constant.STATUS_OF_USER.NOT_INVITED
        });
        return <div className={`${classNameStatus}`}>{status}</div>;
    };

    const renderTblUserList = () => {
        return (
            <div className="table-tbl table-tbl--account">
                {/*table form add b2c customer */}
                <Table style={{ borderCollapse: 'separate', borderSpacing: 0 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell className="head-title-info">ユーザー情報</TableCell>
                            <TableCell align="left">ステータス</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!Utils.isEmptyArray(userAddList) &&
                            userAddList.map(user => (
                                <TableRow key={user.id}>
                                    <TableCell className="cell-group-info">
                                        <div className="cell-group-info-wrapper">
                                            <img
                                                src="/assets/image/icon-user-default.svg"
                                                alt=""
                                                className="thumbAccount"
                                            />
                                            <div>
                                                <div className="group-name">
                                                    <TextField
                                                        FormHelperTextProps={{
                                                            className: 'break-word-helper-text'
                                                        }}
                                                        className="form-control-wrapInput form-control-hg32 input-change-width"
                                                        variant="outlined"
                                                        placeholder="姓"
                                                        id={`lastName-${user.id}`}
                                                        value={user.lastName}
                                                        onChange={e =>
                                                            handleTextFieldAddChange(
                                                                e,
                                                                user.id,
                                                                argsAll
                                                            )
                                                        }
                                                        error={
                                                            errorAddList[`${user.id}`] &&
                                                            errorAddList[`${user.id}`].lastName
                                                        }
                                                        helperText={
                                                            errorAddList[`${user.id}`] &&
                                                            errorAddList[`${user.id}`].lastName
                                                        }
                                                    />

                                                    <TextField
                                                        FormHelperTextProps={{
                                                            className: 'break-word-helper-text'
                                                        }}
                                                        className="form-control-wrapInput form-control-hg32 input-change-width"
                                                        variant="outlined"
                                                        placeholder="名"
                                                        id={`firstName-${user.id}`}
                                                        value={user.firstName}
                                                        onChange={e =>
                                                            handleTextFieldAddChange(
                                                                e,
                                                                user.id,
                                                                argsAll
                                                            )
                                                        }
                                                        error={
                                                            errorAddList[`${user.id}`] &&
                                                            errorAddList[`${user.id}`].firstName
                                                        }
                                                        helperText={
                                                            errorAddList[`${user.id}`] &&
                                                            errorAddList[`${user.id}`].firstName
                                                        }
                                                    />
                                                </div>
                                                <div>
                                                    <TextField
                                                        className="form-control-wrapInput form-control-hg32 input-change"
                                                        variant="outlined"
                                                        placeholder="ユーザーID（メールアドレス)"
                                                        id={`mailAddress-${user.id}`}
                                                        value={user.mailAddress}
                                                        onChange={e =>
                                                            handleTextFieldAddChange(
                                                                e,
                                                                user.id,
                                                                argsAll
                                                            )
                                                        }
                                                        error={
                                                            errorAddList[`${user.id}`] &&
                                                            errorAddList[`${user.id}`].email
                                                        }
                                                        helperText={
                                                            errorAddList[`${user.id}`] &&
                                                            errorAddList[`${user.id}`].email
                                                        }
                                                    />
                                                </div>
                                                <div className="phone-input-container">
                                                    <PhoneInput
                                                        country={'jp'}
                                                        value={user.phoneNumber || ''}
                                                        onChange={phoneNumber =>
                                                            handlePhoneNumberChange(
                                                                phoneNumber,
                                                                user.id,
                                                                argsAll
                                                            )
                                                        }
                                                        countryCodeEditable={false}
                                                        inputProps={{
                                                            name: `phoneNumber-${user.id}`,
                                                            className: clsx('form-control', {
                                                                'error-border':
                                                                    errorAddList[`${user.id}`] &&
                                                                    errorAddList[`${user.id}`]
                                                                        .phoneNumber
                                                            })
                                                        }}
                                                        containerStyle={{
                                                            width: '100%'
                                                        }}
                                                        inputStyle={{
                                                            width: '100%',
                                                            height: '32px'
                                                        }}
                                                    />
                                                    {errorAddList[`${user.id}`] && errorAddList[`${user.id}`].phoneNumber && (
                                                        <div className="phone-input-error">
                                                            {errorAddList[`${user.id}`].phoneNumber}
                                                        </div>
                                                    )}
                                                </div>
                                                <div>
                                                    <TextField
                                                        FormHelperTextProps={{
                                                            className: 'break-word-helper-text'
                                                        }}
                                                        className="form-control-wrapInput form-control-hg32 input-change"
                                                        variant="outlined"
                                                        placeholder="組織（会社名）"
                                                        id={`organizationName-${user.id}`}
                                                        value={user.organizationName || ''}
                                                        onChange={e =>
                                                            handleTextFieldAddChange(
                                                                e,
                                                                user.id,
                                                                argsAll
                                                            )
                                                        }
                                                        error={
                                                            errorAddList[`${user.id}`] &&
                                                            errorAddList[`${user.id}`].organizationName
                                                        }
                                                        helperText={
                                                            errorAddList[`${user.id}`] &&
                                                            errorAddList[`${user.id}`].organizationName
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </TableCell>
                                    <TableCell className="cell-group-btn table-row-top">
                                        <div className="action-group action-group-create">
                                            <div className="group-status">
                                                <div className="status-user"></div>
                                            </div>
                                            <div className="groupBtn-action action-delete-add-user">
                                                <Button
                                                    className="btn-action"
                                                    onClick={() => {
                                                        isFillUserData(userAddList, user.id)
                                                            ? setIsOpenDialogConfirmDelete({
                                                                  isEnable: true,
                                                                  userId: user.id
                                                              })
                                                            : reMoveRowProjectUser(
                                                                  argsAll,
                                                                  user.id,
                                                                  userAddList,
                                                                  setUserAddList
                                                              );
                                                    }}
                                                >
                                                    <img
                                                        src="/assets/image/delete-icon.svg"
                                                        alt=""
                                                    />
                                                </Button>
                                            </div>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                    </TableBody>
                    <TableBody>
                        {!Utils.isEmptyArray(customerList) &&
                            customerList.map(user =>
                                isEditMode && user.isEditMode ? (
                                    <TableRow key={user.id}>
                                        <TableCell className="cell-group-info">
                                            <div className="cell-group-info-wrapper">
                                                <img
                                                    src={user.avatar}
                                                    alt=""
                                                    className="thumbAccount"
                                                />
                                                <div>
                                                    <div className="group-name">
                                                        <TextField
                                                            FormHelperTextProps={{
                                                                className: 'break-word-helper-text'
                                                            }}
                                                            className="form-control-wrapInput form-control-hg32 input-change-width"
                                                            variant="outlined"
                                                            placeholder="姓"
                                                            id={`lastName-${user.id}`}
                                                            defaultValue={Utils.getTextByLanguage(
                                                                Constant.LANGUAGE_TYPE.JP,
                                                                user.lastName
                                                            )}
                                                            inputProps={{
                                                                minlength: 1,
                                                                maxlength: 200
                                                            }}
                                                            onChange={e =>
                                                                validateEditUser(
                                                                    e,
                                                                    user.id,
                                                                    argsAll
                                                                )
                                                            }
                                                            error={
                                                                errorEditUser[`${user.id}`] &&
                                                                errorEditUser[`${user.id}`].lastName
                                                            }
                                                            helperText={
                                                                errorEditUser[`${user.id}`] &&
                                                                errorEditUser[`${user.id}`].lastName
                                                            }
                                                        />

                                                        <TextField
                                                            FormHelperTextProps={{
                                                                className: 'break-word-helper-text'
                                                            }}
                                                            className="form-control-wrapInput form-control-hg32 input-change-width"
                                                            variant="outlined"
                                                            placeholder="名"
                                                            id={`firstName-${user.id}`}
                                                            defaultValue={Utils.getTextByLanguage(
                                                                Constant.LANGUAGE_TYPE.JP,
                                                                user.firstName
                                                            )}
                                                            inputProps={{
                                                                minlength: 1,
                                                                maxlength: 200
                                                            }}
                                                            onChange={e =>
                                                                validateEditUser(
                                                                    e,
                                                                    user.id,
                                                                    argsAll
                                                                )
                                                            }
                                                            error={
                                                                errorEditUser[`${user.id}`] &&
                                                                errorEditUser[`${user.id}`]
                                                                    .firstName
                                                            }
                                                            helperText={
                                                                errorEditUser[`${user.id}`] &&
                                                                errorEditUser[`${user.id}`]
                                                                    .firstName
                                                            }
                                                        />
                                                    </div>
                                                    <div>
                                                        <TextField
                                                            className="form-control-wrapInput form-control-hg32 input-change"
                                                            variant="outlined"
                                                            placeholder="ユーザーID（メールアドレス)"
                                                            id={`mailAddress-${user.id}`}
                                                            defaultValue={Utils.getDisplayUserEmailWithoutSuffix(
                                                                user.mail
                                                            )}
                                                            value={user.emailAddress}
                                                            disabled={!user?.isEmailFromPhoneCall}
                                                            onChange={e =>
                                                                validateEditUser(
                                                                    e,
                                                                    user.id,
                                                                    argsAll
                                                                )
                                                            }
                                                            error={
                                                                errorEditUser[`${user.id}`] &&
                                                                errorEditUser[`${user.id}`].email
                                                            }
                                                            helperText={
                                                                errorEditUser[`${user.id}`] &&
                                                                errorEditUser[`${user.id}`].email
                                                            }
                                                        />
                                                    </div>
                                                    <div className="phone-input-container">
                                                        <PhoneInput
                                                            country={'jp'}
                                                            value={user.tel || ''}
                                                            disabled={true}
                                                            countryCodeEditable={false}
                                                            enableLongNumbers={true}
                                                            placeholder="+81"
                                                            inputProps={{
                                                                name: `phoneNumber-${user.id}`,
                                                                className: 'form-control'
                                                            }}
                                                            containerStyle={{
                                                                width: '100%'
                                                            }}
                                                            inputStyle={{
                                                                width: '100%',
                                                                height: '32px'
                                                            }}
                                                        />
                                                    </div>
                                                    <div>
                                                        <TextField
                                                            FormHelperTextProps={{
                                                                className: 'break-word-helper-text'
                                                            }}
                                                            className="form-control-wrapInput form-control-hg32 input-change"
                                                            variant="outlined"
                                                            placeholder="組織（会社名）"
                                                            id={`organizationName-${user.id}`}
                                                            value={user.organizationName || ''}
                                                            onChange={e =>
                                                                validateEditUser(
                                                                    e,
                                                                    user.id,
                                                                    argsAll
                                                                )
                                                            }
                                                            error={
                                                                errorEditUser[`${user.id}`] &&
                                                                errorEditUser[`${user.id}`].organizationName
                                                            }
                                                            helperText={
                                                                errorEditUser[`${user.id}`] &&
                                                                errorEditUser[`${user.id}`]
                                                                    .organizationName
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </TableCell>
                                        <TableCell className="cell-group-btn table-row-top">
                                            <div className="action-group action-group-create">
                                                <div className="group-status">
                                                    {renderStatusUser(Utils.getUserStatus(user))}
                                                </div>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    <TableRow key={user?.id}>
                                        <TableCell className="cell-user-image">
                                            <div className="fixed-with-avatar">
                                                <img
                                                    src={user.avatar}
                                                    alt=""
                                                    className="thumbAccount"
                                                />
                                            </div>
                                            <div>
                                                <OverFlowTooltip
                                                    value={Utils.getFullNameOfUser(
                                                        Constant.LANGUAGE_TYPE.JP,
                                                        user
                                                    )}
                                                />
                                                <div className="cell-user-mail">
                                                    {Utils.getDisplayUserEmailWithoutSuffix(
                                                        user.mail
                                                    )}
                                                </div>
                                                {user?.tel && (
                                                    <div className="cell-user-tel">
                                                            <div className="phone-input-container">
                                                                <PhoneInput
                                                                    country={'jp'}
                                                                    value={user.tel || ''}
                                                                    disabled={true}
                                                                    countryCodeEditable={false}
                                                                    enableLongNumbers={true}
                                                                    placeholder="+81"
                                                                    inputProps={{
                                                                        name: `phoneNumber-display-${user.id}`,
                                                                        className: 'form-control'
                                                                    }}
                                                                    containerStyle={{
                                                                        width: '100%'
                                                                    }}
                                                                    inputStyle={{
                                                                        width: '100%',
                                                                        height: '32px'
                                                                    }}
                                                                />
                                                            </div>
                                                    </div>
                                                )}
                                                {user?.organizationName && (
                                                    <div className="cell-user-organization">
                                                        {user?.organizationName}
                                                    </div>
                                                )}
                                            </div>
                                        </TableCell>
                                        <TableCell className="cell-group-info">
                                            <div className="action-group">
                                                <div className="group-status">
                                                    {renderStatusUser(Utils.getUserStatus(user))}
                                                </div>
                                                <div>
                                                    <div className="groupBtn-action">
                                                        {!isDisableBtnRestoreB2C(isAdmin, user) && (
                                                            <Button
                                                                className="btn-action"
                                                                disabled={isDisableBtnRestoreB2C(
                                                                    isAdmin,
                                                                    user
                                                                )}
                                                                onClick={() =>
                                                                    handleClickRestoreB2C(
                                                                        argsAll,
                                                                        user
                                                                    )
                                                                }
                                                            >
                                                                <img
                                                                    src="/assets/image/icon-restore.svg"
                                                                    alt=""
                                                                />
                                                            </Button>
                                                        )}
                                                        <Button
                                                            className="btn-action"
                                                            disabled={isDisableBtnEditB2C(
                                                                isAdmin,
                                                                user
                                                            )}
                                                            onClick={() =>
                                                                handleEdit(user, argsAll)
                                                            }
                                                        >
                                                            <img
                                                                src="/assets/image/edit-icon.svg"
                                                                alt=""
                                                            />
                                                        </Button>
                                                        {!isDisableBtnDeleteB2C(argsAll, user) && (
                                                            <Button
                                                                className="btn-action"
                                                                disabled={isDisableBtnDeleteB2C(
                                                                    argsAll,
                                                                    user
                                                                )}
                                                                onClick={() =>
                                                                    onClickDeleteB2C(argsAll, user)
                                                                }
                                                            >
                                                                <img
                                                                    src="/assets/image/delete-icon.svg"
                                                                    alt=""
                                                                    disabled
                                                                />
                                                            </Button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                )
                            )}
                    </TableBody>
                </Table>
                {isOpenDialogConfirmDelete.isEnable && (
                    <ConfirmDeleteAdditionUserDialog
                        argsAll={argsAll}
                        parentScreen={Constant.SCREEN_LIST.B2C_IN_ORG}
                    />
                )}
                {isOpenModalRejectDeleteUser && (
                    <RejectDeleteCustomerUser
                        argsAll={argsAll}
                        isOpen={isOpenModalRejectDeleteUser}
                        setIsOpen={setIsOpenModalRejectDeleteUser}
                    />
                )}
            </div>
        );
    };

    return (
        <>
            <div className="groupUser" data-cy="project-user-list">
                <div className="head-btn">
                    <div className="head-btn-add">
                        {isAdmin && <Button
                            className="btn-add-project"
                            onClick={() => addNewRowProjectCustomer(argsAll)}
                        >
                            <div className="btn-plus-icon">
                                <img src="/assets/image/icon-plus-add.svg" alt="" />
                            </div>
                            <div className="btn-text-add">{I18n.get('USER03BTN005')}</div>
                        </Button>}
                    </div>

                    <div className="head-btn-wrap">
                        <div className="btn-cancel">
                            {(isEditMode || !Utils.isEmptyArray(userAddList)) && <Button
                                className="btn-light btn-hg32"
                                variant="contained"
                                color="primary"
                                disabled = {!(!Utils.isEmptyArray(userAddList) || isEditMode)}
                                onClick={() => {
                                    onClickCancelEdit(argsAll)
                                }}
                            >
                                {I18n.get('COMBTN001')}
                            </Button>}
                        </div>
                        <div className="btn-submit">
                            {(isEditMode || !Utils.isEmptyArray(userAddList)) && <Button
                                className="btn-primary btn-hg32"
                                variant="contained"
                                color="primary"
                                onClick={() => handleSubmit(argsAll)}
                                disabled={isDisableBtnSubmit}
                            >
                                {I18n.get('COMBTN011')}
                            </Button>}
                        </div>
                    </div>
                </div>

                <div className="projectUser-table" data-cy="project-users-table-list">
                    {renderTblUserList()}
                </div>
            </div>
            <CancelEditCustomerList
                {...argsAll}
                isOpen={isOpenModalConfirmCancel}
                setIsOpen={setIsOpenModalConfirmCancel}
                submitAction={() => onSubmitCancelEdit(argsAll)}
            />

            <ConfirmRestoreUser 
                isOpen={isOpenDialogConfirmRestoreUser}
                setIsOpen={setIsOpenDialogConfirmRestoreUser}
                submitAction={() => onSubmitRestoreB2C(argsAll)}
            />

            <DataChangePleaseReloadModal {...argsAll} isOpen={isOpenModalReloadPage} setIsOpen={setIsOpenModalReloadPage} />
            <ConfirmDialog 
                isOpen={!Utils.isEmptyString(editUserError)} 
                okCallBack={() => {setEditUserError('')}} 
                msgConfirm={editUserError}
                textSubmit={I18n.get('COMBTN006')}
            />
        </>
    );
}
